import { Header } from "./header";
import { Helpers } from "./helpers/helpers";
import { MobileHelpers } from "./helpers/mobile-helpers";

export class Navigation {
	public readonly navExpandedClass = 'nav-expanded-open';
	private mainNav: HTMLElement;
	private goBackButton: NodeListOf<Element>;
	constructor(shouldInit = false) {
		this.wrapper = document.querySelector('.wrapper') as HTMLElement;
		this.hamburgerState = document.querySelector('.menu-icon-checkbox') as HTMLFormElement;
		this.mainNav = document.querySelector('.main-nav .navigation') as HTMLElement;
		this.goBackButton = this.mainNav?.querySelectorAll('.mobile-nav-banner a');
		if (shouldInit) {
			this.bindElements();

			if (!Helpers.isEditScreen) {
				this.initiateFixedNav();
			}

		}
	}

	bindElements() {
		
		// Mobile: click-to-expand for mega menu (must be first — capture phase)
		this.initMobileMenuToggle();
		
		//bind mega menu blur overlay
		
		this.initMegaMenuBlur();
		
		
		//bind hamburger
		const header = new Header();
		this.hamburgerState?.addEventListener('change', () => {
			const input = event.target as HTMLInputElement;
			this.wrapper.classList.toggle(this.navExpandedClass);

			if (this.isExpandedNavigationOpen()) {
				header.closeSearchBox();
			}

			if (!MobileHelpers.isBelowMd()) {
				//header.openHeaderSearchBox(false, false);
			}

			if (!input.checked) {
				header.closeSearchBox(true);
			}
		});

		// Mega menu height sync: make left panel grow when right panel is taller
		this.initMegaMenuHeightSync();

		document.querySelectorAll('.sub-navigation a[href^="#"]')?.forEach(anchor => {
			const sectionSelector = anchor.getAttribute('href');
			if (sectionSelector === "#") {
				return;
			}
			const section = document.querySelector(sectionSelector);
			if (!section) {
				anchor.parentElement.classList.add('d-none');
			}
		});

		document.addEventListener('click', (e) => {
			const a = (e.target as Element).closest('a[href^="#"]:not([href="#"])');
			if (!a) return;

			e.preventDefault();

			const selector = a.getAttribute('href')!;
			const target = document.querySelector(selector) as HTMLElement | null;
			if (!target) return;

			const header = document.querySelector('.main-header') as HTMLElement | null;
			const headerH = header ? header.getBoundingClientRect().height : 0;

			// Compute absolute target Y accounting for header height
			const y = window.scrollY + target.getBoundingClientRect().top - headerH;

			window.scrollTo({ top: y, behavior: 'smooth' });
			history.replaceState(null, '', selector);
		});

		window.addEventListener('load', () => {
			if (location.hash) {
				const el = document.querySelector(location.hash) as HTMLElement | null;
				if (!el) return;
				const header = document.querySelector('.main-header') as HTMLElement | null;
				const headerH = header ? header.getBoundingClientRect().height : 0;
				const y = window.scrollY + el.getBoundingClientRect().top - headerH;
				window.scrollTo({ top: y });
			}
		});

		let resourceNav = document.querySelector('.resource-nav')
		let resourceNavLinks = document.querySelectorAll('.resource-nav a')

		if (!Helpers.isNullOrUndefined(resourceNav)) {
			resourceNav.addEventListener('click', (e) => {
				if (window.innerWidth < 768) {
					resourceNav.classList.toggle('expanded');
				}
			});
		}

		resourceNavLinks?.forEach(anchor => {
			const sectionSelector = anchor.getAttribute('href');
			if (sectionSelector === "#") {
				return;
			}
			const section = document.querySelector(sectionSelector);
			if (section) {
				anchor.addEventListener('click',
					(e) => {
						e.preventDefault();
						resourceNavLinks?.forEach(anchor => {
							anchor.classList.remove('active');
						});

						anchor.classList.add('active');

						const link = e.target as HTMLElement;
						const element = document.querySelector(link.getAttribute("href"));
						let yOffset = -155;

						if (!document.querySelector(".main-header.transparent")) {
							yOffset = yOffset * 2;
						}

						const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
						Helpers.scrollTo(y, 1);

					});
			}
		});

	}

	public isExpandedNavigationOpen(): boolean {
		return this.wrapper.classList.contains(this.navExpandedClass);
	}

	public closeExpandedNavigation() {
		this.wrapper.classList.remove(this.navExpandedClass);
		this.hamburgerState.checked = false;
	}

	private initiateFixedNav() {
		const mainHeader = document.querySelector(".main-header");
		if (window.scrollY > 10) {
			mainHeader?.classList.add('fixed');
		} else {
			mainHeader?.classList.remove('fixed');
		}
		window.addEventListener('scroll',
			() => {
				if (window.scrollY > 10) {
					mainHeader?.classList.add('fixed');
				} else {
					mainHeader?.classList.remove('fixed');
				}
			});
	}

	private initMegaMenuHeightSync() {
		// Desktop only. Level 2 panel gets max-height + overflow-y dynamically when
		// its natural content height exceeds the viewport (short menus stay scroll-free).
		// Level 3 child menus would be clipped by that overflow context, so we
		// position them as `fixed` on hover — escapes the parent's clipping entirely.

		// Toggle scroll on level 2 panels (direct children of top-level nav items)
		const level2Panels = document.querySelectorAll('.main-nav .navigation > li > .mega-menu-children');
		level2Panels.forEach(panel => {
			const parentLi = panel.parentElement as HTMLElement;
			if (!parentLi) return;

			// Collect every level-3 panel nested directly under this level-2 panel
			const level3Panels = Array.from(
				panel.querySelectorAll(':scope > li > .mega-menu-children')
			) as HTMLElement[];

			const resetEqualization = () => {
				(panel.querySelectorAll(':scope > li') as NodeListOf<HTMLElement>)
					.forEach(el => el.style.minHeight = '');
				level3Panels.forEach(l3 =>
					(l3.querySelectorAll(':scope > li') as NodeListOf<HTMLElement>)
						.forEach(el => el.style.minHeight = ''));
			};

			// Pre-equalize ALL level-2 items against ALL level-3 panels at once.
			// Heights are locked in before the cursor reaches any individual item,
			// so nothing moves while the user is navigating — no flicker.
			const equalizeAllRows = () => {
				if (MobileHelpers.isBelowLg()) return;

				const l2Items = Array.from(panel.querySelectorAll(':scope > li')) as HTMLElement[];

				// Reset first so we measure natural heights
				l2Items.forEach(el => el.style.minHeight = '');
				level3Panels.forEach(l3 =>
					(l3.querySelectorAll(':scope > li') as NodeListOf<HTMLElement>)
						.forEach(el => el.style.minHeight = ''));

				const maxCount = Math.max(
					l2Items.length,
					...level3Panels.map(l3 => l3.querySelectorAll(':scope > li').length)
				);

				for (let i = 0; i < maxCount; i++) {
					const l2h = l2Items[i]?.offsetHeight ?? 0;
					const l3hs = level3Panels.map(l3 => {
						const item = l3.querySelectorAll(':scope > li')[i] as HTMLElement | undefined;
						return item?.offsetHeight ?? 0;
					});
					const maxH = Math.max(l2h, ...l3hs);

					if (l2Items[i]) l2Items[i].style.minHeight = maxH + 'px';
					level3Panels.forEach(l3 => {
						const item = l3.querySelectorAll(':scope > li')[i] as HTMLElement | undefined;
						if (item) item.style.minHeight = maxH + 'px';
					});
				}
			};

			const applyLevel2Scroll = () => {
				if (MobileHelpers.isBelowLg()) return;
				const el = panel as HTMLElement;
				// Reset first so we measure natural height
				el.style.maxHeight = '';
				el.style.overflowY = '';
				const rect = el.getBoundingClientRect();
				const available = window.innerHeight - rect.top - 10;
				if (el.scrollHeight > available) {
					el.style.maxHeight = available + 'px';
					el.style.overflowY = 'auto';
				}
			};

			parentLi.addEventListener('mouseenter', () => {
				// Equalize first so scroll measurement accounts for grown items
				//equalizeAllRows();
				applyLevel2Scroll();
			});

			parentLi.addEventListener('mouseleave', () => {
				const el = panel as HTMLElement;
				el.style.maxHeight = '';
				el.style.overflowY = '';
				resetEqualization();
			});
		});

		const menuItems = document.querySelectorAll('.navigation > li .mega-menu-children > li');

		menuItems.forEach(li => {
			const childMenu = li.querySelector(':scope > .mega-menu-children') as HTMLElement;
			if (!childMenu) return;

			const parentMenu = li.closest('.mega-menu-children') as HTMLElement;
			if (!parentMenu) return;

			const resetChildMenuPosition = () => {
				childMenu.style.position = '';
				childMenu.style.top = '';
				childMenu.style.left = '';
				childMenu.style.height = '';
				childMenu.style.maxHeight = '';
				childMenu.style.overflowY = '';
				childMenu.style.overflowX = '';
				childMenu.style.zIndex = '';
				childMenu.style.width = '';
				parentMenu.style.minHeight = '';
			};

			const positionFixedChildMenu = () => {
				// Reset min-height before measuring so a previous hover's height
				// doesn't bleed into this item's calculation.
				parentMenu.style.minHeight = '';


				const parentRect = parentMenu.getBoundingClientRect();
				const childNaturalHeight = childMenu.scrollHeight;
				const available = window.innerHeight - parentRect.top - 10;

				// Use the parent's actual rendered height (after any max-height capping),
				// not scrollHeight which includes clipped content.
				const parentVisibleHeight = parentRect.height;

				// Both panels should match the taller of the two, capped at viewport
				const targetHeight = Math.min(Math.max(childNaturalHeight, parentVisibleHeight), available);

				// If level 3 is taller than the visible parent, grow level 2 to match
				if (childNaturalHeight > parentVisibleHeight) {
					parentMenu.style.minHeight = targetHeight + 'px';
				}

				childMenu.style.position = 'fixed';
				childMenu.style.top = parentRect.top + 'px';
				childMenu.style.left = parentRect.right + 'px';
				// Match both panels to the same height
				childMenu.style.height = targetHeight + 'px';
				// Both axes set explicitly so the browser doesn't implicitly promote
				// overflow-x to auto when overflow-y is set.
				childMenu.style.overflowX = 'hidden';

				if (childNaturalHeight > available) {
					// Level 3 truly doesn't fit viewport — cap and scroll.
					childMenu.style.maxHeight = available + 'px';
					childMenu.style.overflowY = 'auto';
				} else {
					childMenu.style.maxHeight = '';
					childMenu.style.overflowY = 'hidden';
				}

				// Fixed-positioned block elements stretch to fill the viewport without an
				// explicit width. Use max-content so the panel sizes to its content while
				// still honoring the CSS min-width (380px).
				childMenu.style.width = 'max-content';
				// Stack above the blur overlay (.wrapper.mega-menu-open::after has z-index: 20)
				childMenu.style.zIndex = '30';
			};

			li.addEventListener('mouseenter', () => {
				if (MobileHelpers.isBelowLg()) return;
				positionFixedChildMenu();
			});

			// Keep level 3 aligned with its parent row when the level 2 panel scrolls
			parentMenu.addEventListener('scroll', () => {
				if (MobileHelpers.isBelowLg()) return;
				if (childMenu.style.position === 'fixed') positionFixedChildMenu();
			}, { passive: true });

			window.addEventListener('resize', () => {
				if (childMenu.style.position === 'fixed') positionFixedChildMenu();
			});

			li.addEventListener('mouseleave', () => {
				resetChildMenuPosition();
			});
		});
	}

	private initMegaMenuBlur() {
		const megaMenuClass = 'mega-menu-open';
		const navItems = this.mainNav?.querySelectorAll(':scope > li');
		if (!navItems) return;

		navItems.forEach(li => {
			// Only target items that have a mega menu child
			if (!li.querySelector(':scope > .mega-menu-children')) return;

			li.addEventListener('mouseenter', () => {
				this.wrapper.classList.add(megaMenuClass);
			});

			li.addEventListener('mouseleave', () => {
				this.wrapper.classList.remove(megaMenuClass);
			});
		});

		// Safety net: if mouse leaves the entire nav area, always remove the class
		this.mainNav.addEventListener('mouseleave', () => {
			this.wrapper.classList.remove(megaMenuClass);
		});


	}

	private initMobileMenuToggle() {
		// Use a single capture-phase handler on the nav element itself.
		// Capture fires top-down, before anything else processes the event.
		if (!this.mainNav) return;

		const handler = (e: Event) => {
			if (!MobileHelpers.isBelowLg()) return;

			const target = e.target as HTMLElement;
			if (!target) return;

			// Find the anchor that was clicked (or its ancestor anchor)
			let anchor = target.closest('a') as HTMLAnchorElement;
			
			// If no anchor found, check if user tapped the icon/submenu-indicator
			// which is a sibling of the <a>, not inside it
			let li: HTMLElement;
			if (!anchor) {
				// Check if we clicked an icon/svg element that's a direct child of an <li>
				li = target.closest('li') as HTMLElement;
				if (!li) return;
				anchor = li.querySelector(':scope > a') as HTMLAnchorElement;
				if (!anchor) return;
			} else {
				// Find the <li> parent of this anchor
				li = anchor.parentElement as HTMLElement;
				if (!li || li.tagName !== 'LI') return;
			}

			// Check if this <li> has a direct child submenu
			const submenu = li.querySelector(':scope > .mega-menu-children');
			if (!submenu) return; // No submenu = allow normal navigation

			// This item has children — prevent navigation and toggle
			e.preventDefault();
			e.stopImmediatePropagation();

			const isOpen = li.classList.contains('mobile-open');

			// Close siblings at the same level
			const siblings = li.parentElement?.querySelectorAll(':scope > li.mobile-open');
			siblings?.forEach(sib => {
				if (sib !== li) {
					sib.classList.remove('mobile-open');
					sib.querySelectorAll('.mobile-open').forEach(nested => nested.classList.remove('mobile-open'));
				}
			});

			li.classList.toggle('mobile-open', !isOpen);
		};

		// Capture phase on the nav container — fires before bubble phase handlers
		this.mainNav.addEventListener('click', handler, true);
		this.goBackButton?.forEach(backButton => {
			backButton.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopImmediatePropagation();

				const target = e.target as HTMLElement;
				if (!target) return;

				// Find the nearest open li ancestor and close it
				const openLi = target.closest('li.mobile-open') as HTMLElement;
				if (!openLi) return;
				openLi.classList.remove('mobile-open');
			});
		})
	}

	wrapper: HTMLElement;
	hamburgerState: HTMLFormElement;


}
